import axios from "axios";
import { API_BASE_URL } from "../apiClient";

const endpoint = `${API_BASE_URL}/api/admin/farm-care-updates`;
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`, "Content-Type": "application/json" } });

const farmCareService = {
  list(batchId, category) {
    const params = { batchId };
    if (category) params.category = category;
    return axios.get(endpoint, { ...config(), params }).then((response) => response.data);
  },
  create(payload) {
    return axios.post(endpoint, payload, config()).then((response) => response.data);
  },
  update(id, payload) {
    return axios.put(`${endpoint}/${id}`, payload, config()).then((response) => response.data);
  },
  remove(id) {
    return axios.delete(`${endpoint}/${id}`, config());
  },
};

export default farmCareService;
